<template>
  <div class="mr-2">
    <v-btn
      icon
      color="white"
      @click="generateReport()"
    >
      <v-icon>mdi-file-pdf-box</v-icon>
    </v-btn>
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Formato poligrafía"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      :html-to-pdf-options="options"
    >
      <section slot="pdf-content">
        <v-container class="margin">
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="6">
                  <img
                    src="@/assets/img/logo-puebla.png"
                    width="100%"
                    alt="test"
                  >
                </v-col>
                <v-spacer />
                <v-col cols="5">
                  <v-simple-table class="font">
                    <template #default>
                      <thead>
                        <tr>
                          <th>DEPARTAMENTO DE POLIGRAFIA</th>
                        </tr>
                        <tr>
                          <th>
                            Programación: {{ evaluacion.Derivacion
                              .Programacion.oficioProgramacion }}
                          </th>
                        </tr>
                        <tr>
                          <th>Folio: {{ evaluacion.Derivacion.Programacion.Expediente.folio }}</th>
                        </tr>
                      </thead>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-simple-table class="font">
                <template #default>
                  <thead>
                    <tr>
                      <th>INFORMACIÓN DE EVALUACIÓN POLIGRÁFICA</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <v-container>
                        <v-row>
                          <v-col cols="9">
                            <v-row>
                              <v-col cols="6">
                                Nombre: {{ getFullName(evaluacion.Derivacion
                                  .Programacion.Expediente.Personal) }}
                              </v-col>
                              <v-col cols="4">
                                Edad:
                                {{ getAge(evaluacion.Derivacion.Programacion
                                  .Expediente.Personal.fechaNacimiento) }} años
                              </v-col>
                              <v-col cols="2">
                                Sexo: {{ evaluacion.Derivacion.Programacion
                                  .Expediente.Personal.CatSexo.title }}
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="8">
                                Institución:
                                {{ evaluacion.Derivacion.Programacion.Expediente
                                  .Personal.unidadAnalisisTactico }}
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="8">
                                Puesto: {{ evaluacion.Derivacion.Programacion
                                  .Expediente.Personal.unidadOperaciones }}
                              </v-col>
                              <v-col cols="4">
                                RFC: {{ evaluacion.Derivacion.Programacion
                                  .Expediente.Personal.rfc }}
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="6">
                                Escolaridad:
                              </v-col>
                              <v-col
                                v-if="evaluacion.Derivacion.Programacion.CatMotivoEvaluacion"
                                cols="6"
                              >
                                Motivo de evaluación: {{ evaluacion.Derivacion
                                  .Programacion.CatMotivoEvaluacion.title }}
                              </v-col>
                              <v-col
                                v-else
                                cols="6"
                              >
                                Motivo de evaluación: NO REGISTRADO
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="7">
                                Antigüedad: {{ evaluacion.Derivacion.Programacion
                                  .Expediente.antiguedadInstitucion }} años
                              </v-col>
                              <v-col cols="5">
                                Fecha de evaluación:
                                {{ getDate(evaluacion.Derivacion.Programacion
                                  .fechaEvaluacionPsicologica) }}
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="3">
                            <img
                              :src="evaluacion.Derivacion.Programacion.Expediente.Personal.foto"
                              crossorigin="anonymous"
                              width="100%"
                              alt="img"
                            >
                          </v-col>
                        </v-row>
                      </v-container>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="12">
              <v-simple-table class="font">
                <template #default>
                  <thead>
                    <tr>
                      <th>INFORMACIÓN CONFIDENCIAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-row>
                              <v-col cols="12">
                                ANTECEDENTES LABORALES
                              </v-col>
                              <v-col cols="12">
                                {{ evaluacion.antecedentesLaborales }}
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                SITUACIÓN PATRIMONIAL
                              </v-col>
                              <v-col cols="12">
                                {{ evaluacion.situacionPatrimonial }}
                              </v-col>
                              <v-col
                                cols="12"
                                align="center"
                              >
                                ADMISIONES:
                              </v-col>
                              <v-col
                                cols="12"
                                align="center"
                              >
                                {{ evaluacion.admisiones }}
                              </v-col>
                              <v-col
                                cols="12"
                                align="center"
                              >
                                OBSERVACIONES:
                              </v-col>
                              <v-col
                                cols="12"
                                align="center"
                              >
                                {{ evaluacion.observaciones }}
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                En el exámen poligráfico se formularon las siguientes preguntas:
                              </v-col>
                              <v-col
                                cols="11"
                                offset="1"
                              >
                                <li
                                  v-for="(pregunta, index) in evaluacion.preguntas"
                                  :key="index"
                                >
                                  <div>Pregunta: {{ pregunta.pregunta }}</div>
                                  <div>Puntaje: {{ pregunta.puntaje }}</div>
                                </li>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="12">
              <v-simple-table class="font">
                <template #default>
                  <thead>
                    <tr>
                      <th>SÍNTESIS TÉCNICA</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            {{ evaluacion.sintesisTecnica }}
                          </v-col>
                        </v-row>
                      </v-container>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="12">
              <v-simple-table class="font">
                <template #default>
                  <thead>
                    <tr>
                      <th>ANÁLISIS NUMÉRICO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <v-container>
                        <v-row>
                          <template v-for="(indicador, index) in evaluacion.indicadores">
                            <v-col
                              v-if="index % 2 === 0"
                              :key="index"
                              cols="3"
                              align="center"
                              class="bordered"
                            >
                              {{ indicador.indicador }}
                            </v-col>
                          </template>
                        </v-row>
                        <v-row>
                          <template v-for="(indicador, index) in evaluacion.indicadores">
                            <v-col
                              v-if="index % 2 !== 0"
                              :key="index"
                              cols="3"
                              align="center"
                              class="bordered"
                            >
                              {{ indicador.indicador }}
                            </v-col>
                          </template>
                        </v-row>
                      </v-container>
                    </tr>
                    <tr>
                      <v-container>
                        <v-row>
                          <v-col cols="3">
                            DIAGNÓSTICO PRELIMINAR:
                          </v-col>
                          <v-col cols="9">
                            {{ evaluacion.diagnosticoPreliminar }}
                          </v-col>
                        </v-row>
                      </v-container>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="6">
              <v-simple-table class="font">
                <template #default>
                  <thead>
                    <tr>
                      <th>ELABORÓ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr />
                    <tr>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                            align="center"
                          >
                            {{ evaluacion.CatEvaluadorElaboro.evaluador }}
                          </v-col>
                        </v-row>
                      </v-container>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="6">
              <v-simple-table class="font">
                <template #default>
                  <thead>
                    <tr>
                      <th>REVISÓ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr />
                    <tr>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                            align="center"
                          >
                            {{ evaluacion.evaluadorReviso }}
                          </v-col>
                        </v-row>
                      </v-container>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="12">
              <v-simple-table class="font">
                <template #default>
                  <thead>
                    <tr>
                      <th>CONTROL DOCUMENTAL DE EXPEDIENTE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            Nombre:
                          </v-col>
                          <v-col cols="6">
                            Dependencia:
                          </v-col>
                          <v-col cols="6">
                            Fecha de entrega a archivo:
                          </v-col>
                        </v-row>
                      </v-container>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="12">
              <v-simple-table class="font">
                <template #default>
                  <thead>
                    <tr>
                      <th>CONTENIDO DEL EXPEDIENTE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="6"
                            align="center"
                          >
                            FORMATOS DE EVALUACIÓN
                          </v-col>
                          <v-col
                            cols="3"
                            align="center"
                          >
                            NO. DE HOJAS
                          </v-col>
                          <v-col
                            cols="3"
                            align="center"
                          >
                            DOCUMENTO INTEGRADO
                          </v-col>
                          <v-col cols="12">
                            <v-row
                              v-for="(contenido, index) in contenidoExpediente"
                              :key="index"
                            >
                              <v-col cols="6">
                                {{ contenido.text }}
                              </v-col>
                              <v-col
                                cols="3"
                                align="center"
                              >
                                0
                              </v-col>
                              <v-col
                                v-if="index !== 7"
                                cols="3"
                                align="center"
                              >
                                X
                              </v-col>
                              <v-col
                                v-else
                                cols="3"
                                align="center"
                              >
                                N/A
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-spacer />
                          <v-col cols="4">
                            TOTAL DE FOJAS: 0
                          </v-col>
                        </v-row>
                      </v-container>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="6">
              <v-simple-table class="font">
                <template #default>
                  <thead>
                    <tr>
                      <th>JEFE DE DEPARTAMENTO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                            align="center"
                          >
                            DPL0
                          </v-col>
                        </v-row>
                      </v-container>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col
              cols="12"
              class="font"
            >
              Toda la información contenida en el presente documento está catalogada
              como CONFIDENCIAL de conformidad con la normatividad
              aplicable en los Artículos 3 Fracción II y 18 de la Ley Federal
              de Transparencia y Acceso a la Información Pública Gubernamental y
              por el Artículo 25 de la Ley de Acceso a la Información Pública
              y Protección de Datos Personales para el Estado de Morelos.
            </v-col>
          </v-row>
        </v-container>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import moment from 'moment';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  components: {
    VueHtml2pdf,
  },

  props: {
    evaluacion: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      options: {
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: false,
        },
        margin: [8, 0, 8, 0],
      },
      contenidoExpediente: [
        { text: 'DIAGNÓSTICO' },
        { text: 'DATOS PERSONALES' },
        { text: 'AUTORIZACIÓN DE EVALUACIÓN Y TEMAS' },
        { text: 'ANTECEDENTES PERSONALES' },
        { text: 'ENTREVISTA' },
        { text: 'HOJA DE CALIFICACIONES' },
        { text: 'HOJA DE COMENTARIOS' },
        { text: 'CANCELACIÓN DE EVALUACIÓN' },
        { text: 'HOJA DE PRESGUNTAS' },
        { text: 'GRÁFICAS' },
      ],
    };
  },

  methods: {
    /*
            Generate Report using refs and calling the
            refs function generatePdf()
        */
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },

    getDate(fecha) {
      return moment(fecha).format('DD/MM/YYYY');
    },
  },
};
</script>

<style scoped>
    .font {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
    }
    th,
    tr {
        border: 1px solid;
    }
    .logo {
        border: 1px solid;
        height: 80px;
    }
    .mt {
        margin-top: 100px;
    }
    .margin {
        padding: 8px 48px 8px 48px;
    }

    .bordered {
        border: 1px solid;
    }
</style>
